<template>
  <div v-bind:class="amplifyUI.formSection" class="login-form reset">
    <div v-bind:class="amplifyUI.sectionHeader">{{options.header}}
      <div v-bind:class="amplifyUI.hint" class="welcome-text" v-if="!mersBranded">
        {{$Amplify.I18n.get('We will email you a verification code that will allow you to reset your password.')}}
        <!-- <a
          v-bind:class="amplifyUI.a"
          v-on:click="$router.push('/forgotusername')"
        >{{$Amplify.I18n.get('Find username')}}</a> -->
      </div>
      <div v-bind:class="amplifyUI.hint" class="mt-1" v-else>
        <a
          v-bind:class="amplifyUI.a"
          v-on:click="$router.push('/forgotusername')"
        >{{$Amplify.I18n.get('Forgot username?')}}</a>
      </div>
    </div>
    <div v-bind:class="amplifyUI.sectionBody">
      <div v-bind:class="amplifyUI.formField">
        <div v-bind:class="amplifyUI.inputLabel">{{$Amplify.I18n.get('Username')}}</div>
        <input
          v-bind:class="amplifyUI.input"
          v-model="username"
          :placeholder="$Amplify.I18n.get('Enter your username')"
          autofocus
          aria-label="username"
          @keyup.enter="submit"
        />
      </div>
      <div v-bind:class="amplifyUI.formField" v-if="sent">
        <div v-bind:class="amplifyUI.inputLabel">{{$Amplify.I18n.get('Code')}}</div>
        <input
          v-bind:class="amplifyUI.input"
          v-model="code"
          aria-label="code"
          autocomplete="new-code"
          :placeholder="$Amplify.I18n.get('Code')"
          autofocus
        />
      </div>
      <div v-bind:class="amplifyUI.formField" v-if="sent">
        <div v-bind:class="amplifyUI.inputLabel">{{$Amplify.I18n.get('New Password')}}</div>
        <input
          v-bind:class="amplifyUI.input"
          v-model="password"
          type="password"
          aria-label="password"
          autocomplete="new-pass"
          :placeholder="$Amplify.I18n.get('New Password')"
        />
        <div
          class="bottom-margin v-messages theme--light v-messages__message"
        >At least 8 characters, 1 number, 1 lowercase and 1 uppercase letter</div>
      </div>
      <div v-bind:class="amplifyUI.formField" v-if="sent">
        <div v-bind:class="amplifyUI.inputLabel">Confirm Password</div>
        <input
          v-bind:class="amplifyUI.input"
          v-model="password2"
          type="password"
          aria-label="password 2"
          autocomplete="new-pass2"
          :placeholder="$Amplify.I18n.get('New Password')"
          @keyup.enter="verify"
        />
      </div>
    </div>
    <div v-bind:class="amplifyUI.sectionFooter">
      <span v-bind:class="amplifyUI.sectionFooterPrimaryContent">
        <a class="lht-blue mr-5" v-on:click="$router.push('/')">Return to log in</a>
        <v-btn
          v-if="!sent"
          v-bind:class="amplifyUI.button"
          v-on:click="submit"
          :loading="buttonLoad"
          dark
          depressed
          :color="appButtonColor"
          large
          class="ma-0 load-button"
        >{{$Amplify.I18n.get('Send Code')}}</v-btn>
        <v-btn
          v-if="sent"
          v-bind:class="amplifyUI.button"
          v-on:click="verify"
          :loading="buttonLoad"
          dark
          depressed
          :color="appButtonColor"
          large
          class="ma-0 load-button"
        >{{$Amplify.I18n.get('Submit')}}</v-btn>
      </span>
      <span v-bind:class="amplifyUI.sectionFooterSecondaryContent">
        <a v-if="!sent" class="lht-blue code" v-on:click="sent = true">I have a code</a>
        <a
          v-if="sent"
          class="lht-blue code"
          v-on:click="submit"
        >{{$Amplify.I18n.get('Resend Code')}}</a>
      </span>
    </div>
    <div class="forgotError" v-if="error">{{ error }}</div>
    <v-dialog v-model="dialog" scrollable width="600px" persistent>
      <v-card>
        <v-card-text class="pa-0">
          <privacy />
        </v-card-text>
        <v-card-actions>
          <v-btn :color="appButtonColor" @click="printMe">Print</v-btn>
          <v-spacer></v-spacer>
          <v-btn :color="appButtonColor" @click="getAnswer(false)">Decline</v-btn>
          <v-btn :color="appButtonColor" @click="getAnswer(true)">Accept</v-btn>
        </v-card-actions>
      </v-card>
      </v-dialog>
  </div>
</template>

<script>
import { AmplifyEventBus } from "aws-amplify-vue";
import * as AmplifyUI from "@aws-amplify/ui";
import { mapState } from "vuex";
import Privacy from "@/components/Privacy.vue";
import VueHtmlToPaper from "@/plugins/print";
export default {
  name: "ForgotPassword",
  props: ["forgotPasswordConfig"],
  components: {
    Privacy
  },
  mixins: [VueHtmlToPaper],
  data() {
    return {
      username: "",
      dialog: false,
      userResponse: true,
      terms: false,
      buttonLoad: false,
      code: "",
      password: "",
      password2: "",
      error: "",
      sent: false,
      logger: {},
      amplifyUI: AmplifyUI
    };
  },
  watch: {
    resetUser() {
      this.username = this.resetUser;
    }
  },
  computed: {
    ...mapState("user", [
      "resetUser",
      "retirementBranded",
      "retirementBrandedTitle",
      "mersBranded",
      "mersBrandedTitle",
      "step"
    ]),
    appButtonColor() {
      return this.mersBranded ? "#33715A" : "#0C2B4A";
    },
    options() {
      const defaults = {
        // header: this.retirementBranded
        //   ? "Reset Retirement Account Access"
        //   : this.mersBranded
        //   ? "Reset MERS Account Access"
        //   : "Reset MY ALERUS password"
        header: "Forgot Password?"
      };
      return Object.assign(defaults, this.forgotPasswordConfig || {});
    }
  },
  mounted() {
    this.logger = new this.$Amplify.Logger(this.$options.name);
  },
  methods: {
    getAnswer(val) {
      if (val) {
        if (this.step === 2) {
          this.$store.commit("user/increaseStep");
          this.userResponse = true;
          this.terms = true;
          this.dialog = false;
          this.$Amplify.Auth.signIn({
            username: this.username.toLowerCase().trim(),
            password: this.password,
            validationData: {
              newUsername: this.username.toLowerCase().trim(),
              agreedTerms: new Date().toISOString(),
              terms: `${this.terms}`
            }
          }).then(user => {
            this.$store.commit("user/setMfa", true)
            this.$store.commit("user/setUser", user)
            this.$router.push("/")
          }).catch(error => {
            this.setError(error)
            return AmplifyEventBus.$emit("authState", "signedOut")
          })
        } else {
          this.$store.commit("user/increaseStep");
        }
      } else {
        this.userResponse = false;
        this.dialog = false;
      }
    },
    async submit() {
      this.buttonLoad = true
      await this.$Amplify.Auth.forgotPassword(this.username.toLowerCase().trim())
        .then(({ CodeDeliveryDetails: { Destination } }) => {
          // create log for password reset code
          this.$store.dispatch("user/createLog", {
            username: this.username.toLowerCase().trim(),
            log: "ResetPasswordCode",
            app: "MyAlerus"
          });
          this.error = `If the username exists, a verification code has been sent to the email address you provided at registration. Please wait for the code to arrive. Resending a code will send a new code number making the first code sent invalid.`;
          this.sent = true;
          this.logger.info("forgotPassword success");
        })
        .catch(e => {
          var registerDate = this.mersBranded ? "4/7/2020" : "9/17/19";
          var signUpText = this.mersBranded ? "Create Account" : "Sign Up";
          if (
            e.message === "User password cannot be reset in the current state."
          ) {
            this.setError("Please sign in first to continue");
          } else if (
            e.message === "UserMigration failed with error no user found."
          ) {
            this.setError(
              "Username not found. Please select Create Account from the Sign In screen."
            );
          } else if (
            e.message ===
            "UserMigration failed with error Cannot read property 'agreedTerms' of null."
          ) {
            this.setError(
              "Due to the enhanced security measures added on " +
                registerDate +
                ", you will need to re-create your account by selecting " +
                signUpText +
                "."
            );
          } else if (e.message === "Username/client id combination not found.") {
            this.error = `If the username exists, a verification code has been sent to the email address you provided at registration.`;
            this.sent = true;
          } else {
            this.setError(e);
          }
        });
      this.buttonLoad = false
    },
    printMe() {
      if (this.step === 1) {
        this.htmlToPaper("consent");
      } else {
        this.htmlToPaper("print");
      }
    },
    async verify() {
      this.error = "";
      if (this.password !== this.password2) {
        this.error = "Password does not match";
        return;
      }
      this.buttonLoad = true
      await this.$Amplify.Auth.forgotPasswordSubmit(
        this.username.toLowerCase().trim(),
        this.code,
        this.password
      )
        .then(async () => {
          // create password reset log
          this.$store.dispatch("user/createLog", {
            username: this.username.toLowerCase().trim(),
            log: "ResetPassword",
            app: "MyAlerus"
          });
          this.$store.commit("user/setAdminReset", false);
          await this.$Amplify.Auth.signIn(this.username.toLowerCase().trim(), this.password)
            .then(newUser => {
              // create successful sign in attempt log
              // this.$store.dispatch("user/createLog", {
              //   username: this.username.toLowerCase(),
              //   log: "SignIn",
              //   app: "MyAlerus"
              // });
              this.$store.commit("user/setMfa", true)
              this.$store.commit("user/setUser", newUser);
              this.$router.push("/")
              // this.$store.commit("user/setState", "signedIn");
              // return AmplifyEventBus.$emit("authState", "signedIn");
            })
            .catch(err => {
              if (err.message === "PreAuthentication failed with error please accept new terms.") {
                this.dialog = true;
              }
              else {
                this.setError(err);
                return AmplifyEventBus.$emit("authState", "signedOut");
              }
            });

          // this.logger.info("forgotPasswordSubmit success");
          // AmplifyEventBus.$emit("authState", "signedOut");
        })
        .catch(e => {
          this.setError(e);
        });
      this.buttonLoad = false
    },
    signIn: function() {
      AmplifyEventBus.$emit("authState", "signedOut");
    },
    setError: function(e) {
      this.error = this.$Amplify.I18n.get(e.message || e);
      this.logger.error(this.error);
    }
  }
};
</script>

<style lang="scss">
.login-form input {
  border: 1px solid lightgray;
}
.forgotError {
  color: red;
  margin-top: 1rem;
}
.bottom-margin {
  margin-bottom: 10px;
}

.Section__sectionFooter___1T54C {
  border-top: 1px solid #ddd;
  padding-top: 1.5rem;
}
.reset {
  .Input__input___3e_bf{
    width: 50%;
    @media (max-width: 599px) {
      width: 100%;
    }
  }
  .Input__inputLabel___3VF0S {
    margin-top: .5rem;
  }
  .Section__sectionFooterPrimaryContent___2r9ZX {
    align-items: center;
    display: flex;
  }
}
.lht-blue {
  color: #297994 !important;
  font-weight: 600;
  font-size: 1.25rem;
  @media (max-width: 599px) {
    margin-bottom: 1rem;
    display: inline-block;
    &.code {
      margin-top: 1rem;
      margin-bottom: 0;
    }
  }
}
.mers {
  .lht-blue {
    color: #33715A !important;
    font-weight: initial;
  }
}
</style>
